import { Navigate, useParams } from 'react-router';
import { useSession } from '../../data/hooks.tsx';

/** `/p/:id/brainstorm[/:boardId]` → the same board under `/boards` (links made before the rename). */
export function BrainstormRedirect() {
  const session = useSession();
  const { boardId } = useParams();
  return <Navigate to={`/p/${session.id}/boards${boardId ? `/${boardId}` : ''}`} replace />;
}
